


















import Vue from 'vue'

export default Vue.extend({
  name: 'LogoutButton',
  methods: {
    logout () {
      this.$store.dispatch('auth/logout')
        .then(() => {
          this.$router.push({ name: 'login' })
        })
    }
  }
})
